import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tiroir',
  templateUrl: './tiroir.component.html',
  styleUrls: ['./tiroir.component.scss'],
  standalone: false
})
export class TiroirComponent {
  @Input()
  label;

  isContentExpanded: false;

  displayContent(isExpanded) {
    this.isContentExpanded = isExpanded;
  }
}
